<div class="simple-search-container">
    <smart-icon name="search" class="clickable" (click)="globalSearch()"></smart-icon>
    <input #searchBar tid="global_search" class="simple-search" (focus)="toggleDropdown(true)"
        (blur)="toggleDropdown(false)" [(ngModel)]="searchTerm" (keydown)="onKeydown($event)"
        (ngModelChange)="onSearchTermChanged()">
    <kendo-popup #searchPopup id="searchPopup" class="simple-search-popup" [anchor]="searchBar" *ngIf="showPopup">
        <li role="option" class="test-anchor">
            <div class="simple-search-item simple-search-header" *ngIf="minimumIndex===-1"
                [ngClass]="{'active': selectedIndex===-1}" (mouseenter)="onItemHovered(-1)" (click)="onItemClicked()">
                <a target="_self" [href]="'global_search?keyword=' + searchTerm" (click)="linkClicked($event)">
                    <smart-icon name="search" class="inline-icon"></smart-icon>
                    <div class="simple-research-text">Search for <b>{{searchTerm}}</b></div>
                </a>
            </div>
            <div *ngFor="let item of dropdownList; let i = index; trackBy:trackByFn"
                class="simple-search-item simple-search-body" [ngClass]="{'active': selectedIndex===i}"
                (mouseenter)="onItemHovered(i)" (click)="onItemClicked(item)">
                <!-- <tam-simple-search-item [item]=" item">
            </tam-simple-search-item> -->
                <a target="_self" [href]="item.url" (click)="linkClicked($event)">
                    <tam-entity-dropdown-item [entity]="item"></tam-entity-dropdown-item>
                </a>
            </div>
            <div class="simple-search-item simple-search-footer" *ngIf="searching">
                <div class="spinner" loading-spin [isLoading]="true"></div>
            </div>
            <div class="simple-search-item simple-search-footer" *ngIf="!searching&&dropdownList.length===0">
                <div class="simple-research-text no-data">NO DATA FOUND</div>
            </div>
        </li>
    </kendo-popup>
</div>